"use client";

import { useMemo } from "react";
import type { LibraryCourse } from "@/features/dashboard/types";
import type { PricingPlan } from "../api";
import { buildCoursePlanPricingUiModel } from "../lib/resolve-course-plan-pricing-ui-state";

export function useCoursePlanPricingUiModel(
  ownedCourse: LibraryCourse | undefined,
  isAuthenticated: boolean,
  plans: PricingPlan[],
) {
  const isOwned = !!ownedCourse;
  return useMemo(
    () =>
      buildCoursePlanPricingUiModel({
        plans,
        ownedCourse,
        isAuthenticated,
        isOwned,
      }),
    [plans, ownedCourse, isAuthenticated, isOwned],
  );
}
